import { service } from "../utils/service";
import { localPath } from "./api.js";

// 门店员工修改密码接口
export function changePassword(params) {
  return service({
    url: "/api" + "/demay/ssm/staffLogin/changePassword",
    method: "post",
    data: params
  });
}
//退出登录
export function logout(params) {
  return service({
    url: "/api" + "/demay/ssm/staffLogin/logout",
    method: "post",
    data: params
  });
}

export function getQRCode(params) {
  return service({
    url: "/api" + "/zfImg/getQRCode",
    method: "get",
    params
  });
}

export function addQRCode(params) {
  return service({
    url: "/api" + "/zfImg/addQRCode",
    method: "post",
    data: params
  });
}

export function deleteQRCode(params) {
  return service({
    url: "/api" + "/zfImg/delete",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/logout.js